import api from '.'
import { User } from './users'
import { Mission } from './missions'
import { Employer } from './organizations'
import { WorkPeriod } from './work-periods'
import { WorkPeriodClocking } from '../../../backend/src/services/resources/work-periods/work-period.model'

const POPULATE = [
  'mission',
  'user',
  'mission.interimAgency',
  'mission.employer',
  'employer',
  'workPeriod',
]

//TODO: use backend types

export enum ClockingTypeEnum {
  start = 'start',
  end = 'end',
}

interface ClockingWorkPeriod extends Omit<Omit<WorkPeriod, 'start'>, 'end'> {
  start: { date: Date; clocking?: WorkPeriodClocking }
  end: { date: Date; clocking?: WorkPeriodClocking }
}

export interface ClockingMission extends Omit<Mission, 'workPeriods'> {
  workPeriods: ClockingWorkPeriod[]
}

export interface Clocking {
  createdAt: Date
  user: User['_id'] | User
  date: Date
  _id: string
  mission?: ClockingMission
  employer?: Employer
  workPeriod?: WorkPeriod
  type?: ClockingTypeEnum
  matchingMission?: ClockingMission
  candidateWorkPeriods?: WorkPeriod[]
}

export interface FetchClockingsParams {
  limit?: number
  start?: Date
  end?: Date
  user?: string[]
  workPeriod?: string
  // 'null' (string) is parsed by mongoose-query-parser as { field: null } in MongoDB,
  // filtering for documents where the field is absent/null (i.e. unregistered clockings)
  type?: ClockingTypeEnum | 'null'
  mission?: string | 'null'
}

export const fetch = async (params: FetchClockingsParams): Promise<Clocking> => {
  const { start, end, user, workPeriod, type, mission } = params

  return await api({
    endpoint: '/clockings',
    method: 'get',
    params: {
      sort: '-createdAt',
      'date>': start,
      'date<': end,
      populate: POPULATE,
      limit: params?.limit,
      workPeriod,
      type,
      mission,
      user,
    },
  })
}

export interface ClockingCreationPayload {
  hash: { content: string; iv: string }
}

export const fetchOne = async (id: string): Promise<Clocking> => {
  return await api({
    endpoint: `/clockings/${id}`,
    method: 'get',
    params: { populate: POPULATE },
  })
}

export const create = async (params: ClockingCreationPayload): Promise<Clocking> => {
  return await api({
    endpoint: '/clockings',
    method: 'post',
    params,
  })
}
